<!--
 * @Description: 面包屑
 * @Author: Xiaochun liu
 * @Date: 2023-10-08 11:48:16
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2024-11-28 18:30:18
-->
<script setup lang="ts">
import { useRoute } from 'vue-router'
import { createPathMap } from './pathMap'

import { useWorkspaceStore } from '@/store'

const workspaceStore = useWorkspaceStore()

const route = useRoute()
const router = useRouter()
const pathMap = computed(() => createPathMap({ isPersonal: workspaceStore.isPersonal, query: route.query }))
const breadcrumbList = computed(() => {
  const arr = pathMap.value.filter((item: any) => item.name === route.name)
  // if (route.name === 'CreateProductView' && !route.query.archiveId) { // 首页跳添加产品信息页, 没有产品详情
  //   // 删掉arr[0].list数组内的第二个
  //   arr[0].list.splice(1, 1)
  // }
  return (arr && arr.length) ? arr[0].list.filter((item: any) => item) : []
})
const jumpHandle = (breadcrumb: any) => {
  // if (route.params) {
  //   router.push({
  //     path: breadcrumb.path,
  //     params: route.params,
  //     query: route.query,
  //   })
  //   return
  // }
  router.push({
    path: breadcrumb.path,
    query: breadcrumb.name === '平台知识库' ? null : breadcrumb.name === '提案工作台' ? { workspace: route.query.workspace } : route.query,
  })
}
</script>

<template>
  <div v-show="breadcrumbList && breadcrumbList.length" class="breadcrumb-wrapper">
    <div v-for="(breadcrumb, index) in breadcrumbList" :key="breadcrumb.path" class="breadcrumb-item">
      <button v-if="index !== breadcrumbList.length - 1" @click="jumpHandle(breadcrumb)">
        {{ breadcrumb.name }}
      </button>
      <div v-if="index === breadcrumbList.length - 1">
        {{ breadcrumb.name }}
      </div>
      <div v-if="index !== breadcrumbList.length - 1" class="separator">
        /
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.breadcrumb-wrapper {
  display: flex;
  align-items: center;
  height: 32px;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px 0px rgba(168, 192, 214, 0.08);
  padding: 11px 20px;
  box-sizing: border-box;
  z-index: 1;

  .breadcrumb-item {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #425466;
    line-height: 22px;

    .separator {
      padding: 0 4px;
    }

    &:last-child {
      color: #8FA1B2;

      &:hover {
        &::after {
          width: 0;
        }
      }
    }

    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 1px;
      background-color: #425466;
      left: 0;
      bottom: 0;
      transition: width .3s cubic-bezier(.165, .84, .44, 1);
    }

    &:hover {
      &::after {
        width: calc(100% - 13px);
      }
    }
  }
}
</style>
